import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { SCREEN_BREAKPOINTS } from "app-constants";
import { useMediaMaxWidth } from "hooks";
import { makeBEM } from "utils";

import { AppSidebar } from "../AppSidebar";
import { AppTopbar } from "../AppTopbar";

import "./index.scss";

const bem = makeBEM("app-layout");

export const AppLayout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const location = useLocation();
  const { i18n } = useTranslation();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  const onMobile = useMediaMaxWidth(SCREEN_BREAKPOINTS.tablet);

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  return (
    <>
      <div className={bem(null, { mobile: onMobile }, [i18n.dir()])} dir={i18n.dir()}>
        <AppTopbar onSidebarToggle={toggleSidebar} sidebarToggleVisible={onMobile} />
        <AppSidebar mobileOpen={isSidebarOpen} mobile={onMobile} onClose={closeSidebar} direction={i18n.dir()} />
        <main className="app-content">{children}</main>
        <div className={bem("background")} />
      </div>
    </>
  );
};
